import React from "react";
import { Box, Typography, Grid, Card, CardContent, Avatar } from "@mui/material";

const items = [
    {
        img: "/assets/chapter-learn-12.png",
        title: "Simple science-based activities",
        desc: "Explore simple science-based activities that strengthen family bonds.",
    },
    {
        img: "/assets/chapter-learn-13.png",
        title: "Small moments of appreciation and kindness",
        desc: "Learn how small moments of appreciation and kindness can shift the whole home atmosphere.",
    },
    {
        img: "/assets/chapter-learn-14.png",
        title: "Create new rituals",
        desc: "Create new rituals that bring more laughter, calm, and connection into everyday life.",
    },
];

export default function ThroughThisChapter() {
    return (
        <Box maxWidth="1120px" mx="auto" py={6} display="flex" flexDirection="column" alignItems="center">
            <Typography
                variant="h4"
                
                fontWeight={400}
                mb={2}
                align="center"
            >
                <strong>Through This Chapter, You’ll Learn</strong>
            </Typography>
            <Typography
                variant="h5"
                
                fontWeight={400}
                mb={4}
                align="center"
            >
                What's inside?
            </Typography>
            <Grid container spacing={3} justifyContent="center">
                {items.map((item, idx) => (
                    <Grid item xs={12} md={4} key={idx} display="flex" justifyContent="center">
                        <Card elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", p: 2 }}>
                            <Avatar
                                src={item.img}
                                alt={item.title}
                                sx={{ width: 100, height: 100, mb: 2 }}
                                variant="square"
                            />
                            <CardContent sx={{ flexGrow: 1, textAlign: "center" }}>
                                <Typography
                                    variant="h6"
                                    
                                    fontWeight={400}
                                    mb={1}
                                >
                                    <strong>{item.title}</strong>
                                </Typography>
                                <Typography
                                    variant="body1"
                                    
                                    fontWeight={400}
                                    color="text.secondary"
                                >
                                    {item.desc}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}